import { getSettingMultimodalProductSearch } from "@faire/retailer-visitor-shared/settings/useSettingMultimodalProductSearch";

import {
  decodeMultimodalQueryInternal,
  encodeMultimodalQueryInternal,
} from "./__internal__/multimodalQueryInternal";

/**
 * Encodes a text and images url into a single string to represent a multimodal query
 *
 * This should be only used on the client.
 **/
export const encodeMultimodalQuery = (
  text: string,
  imageUrls: string[]
): string => {
  return getSettingMultimodalProductSearch()
    ? encodeMultimodalQueryInternal(text, imageUrls)
    : text;
};

/**
 * Decodes a multimodal query string into a text and images url.
 * Returns undefined if the query is not a multimodal query or if the feature is disabled.
 *
 * This should be only used on the client.
 */
export const decodeMultimodalQuery = (
  query: string | undefined
): { text: string; imageUrls: string[] } | undefined => {
  return getSettingMultimodalProductSearch()
    ? decodeMultimodalQueryInternal(query)
    : undefined;
};

// Helper type to ensure that the result type is a string if the input type is a string.
type DecodeMultimodalQueryTextResultType<T extends string | undefined> =
  T extends undefined ? string | undefined : string;

/**
 * Decodes a multimodal query string into a text, returning only the text part.
 * Returns the query if it is not a multimodal query or if the feature is disabled.
 *
 * This should be only used on the client.
 */
export function decodeMultimodalQueryText<T extends string | undefined>(
  query: T
): DecodeMultimodalQueryTextResultType<T> {
  return (
    decodeMultimodalQuery(query)?.text ??
    (query as DecodeMultimodalQueryTextResultType<T>)
  );
}
